import React, { useState } from 'react';
// material
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import CloudIcon from '@material-ui/icons/CloudDownload';
// components
import { CampaignContact } from '../../../entities/site';

interface PropertyHeaderProps {
  contact: CampaignContact;
  onPropertyLoad(contact: CampaignContact): void;
}

const PropertyHeader: React.FC<PropertyHeaderProps> = (props) => {
  
  const classes = useStyles();

  return (
    <div>
      <div className={classes.addressTitle}>Address</div>
      {props.contact.address && 
        <div className={classes.address}>{props.contact.address}, {props.contact.city} {props.contact.state} {props.contact.zip}</div>
      }
      <div>
        <Button
          color="primary"
          startIcon={<CloudIcon />}
          onClick={() => props.onPropertyLoad(props.contact)}
        >
          Get Property Info
        </Button>
      </div>
    </div>
  );

}

export default PropertyHeader;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    addressContainer: {
      padding: 10
    },
    addressTitle: {
      fontWeight: 'bold'
    },
    address: {
      color: '#5D759D',
      fontSize: 16
    }
  })
);


// WEBPACK FOOTER //
// ./src/pages/campaign/components/PropertyHeader.tsx